import { Component, OnInit } from '@angular/core';
import { MobileAppVersionsApiService, TranslationService } from '../../../core/services';
import { MobileAppVersionDto } from '../../interfaces';
import { MobileAppOS, MobileAppType } from '../../enums/administration';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { AppSettings } from '../../models';

@Component({
  selector: 'app-mobile-app-download',
  templateUrl: './mobile-app-download.component.html',
  styleUrls: ['./mobile-app-download.component.scss']
})
export class MobileAppDownloadComponent implements OnInit {
  private _siginInTranslationSubscription: Subscription | null = null;

  public androidVersion: MobileAppVersionDto | null = null;
  public translationsLoaded = false;

  constructor(
    private _mobileAppVersionsApiService: MobileAppVersionsApiService,
    private _translationService: TranslationService,
    private _titleService: Title,
    private _sanitizer: DomSanitizer

  ) { }

  public ngOnInit(): void {
    this.loadMobileAppTranslations();
    this._mobileAppVersionsApiService.getVersion(MobileAppOS.android, MobileAppType.timeSwift).subscribe(
      response => {
        this.androidVersion = response;
        if (!!this.androidVersion?.url) {
          const urlParts = this.androidVersion.url.split('/');
          this.androidVersion.fileName = urlParts[urlParts.length - 1];
          this.androidVersion.safeUrl = this._sanitizer.bypassSecurityTrustUrl(this.androidVersion.url);
        }
      },
      _ => {
        this.androidVersion = null;
      });
  }

  private loadMobileAppTranslations(): void {
    this._siginInTranslationSubscription = this._translationService.translationsLoaded.subscribe(_ => {
      this.translationsLoaded = true;
      this._siginInTranslationSubscription?.unsubscribe();
      this._siginInTranslationSubscription = null;
      // ToDo: Übersetzungen im ApiService Projekt anlegen
      this._titleService.setTitle(`${this._translationService.translate('mobileAppDownload', 'appDownload')} - ${AppSettings.appName}`);
    });

    this._translationService.loadTranslationsSignIn('de-DE');
  }

}
